export const CHROME_WEBSTORE_URL = 'https://chromewebstore.google.com/detail/lictor/ahciohfmmikplckgapppfaphhhgeldnh';

// sessionStorage: token do link de convite guardado enquanto a pessoa se cadastra/faz login
export const PENDING_INVITE_TOKEN_KEY = 'pending_invite_token';
